import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const AdminRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const location = useLocation();

  if (!user) {
    // Not logged in
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!user.isAdmin) {
    // Not an admin
    return <div className="text-center text-2xl text-red-500 mt-20">Not Authorized</div>;
  }
  return children;
};

export default AdminRoute; 